import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
    "Two-level underground stacking system",
    "Independent vehicle access with minimal ground usage",
    "Ideal for compact residential or commercial plots",
    "Fully motorized platform movement and secure locking",
    "Weather-protected and theft-resistant solution",
];

const applications = [
    "Compact Residential Buildings",
    "Small Hospitals or Clinics",
    "Standalone Showrooms",
    "Private Homes & Villas",
    "Urban Commercial Buildings",
];

const TwoLevelPitParkingDetail = () => {
    const navigate = useNavigate()
    return (
        <section className="about-wrapper">
            {/* Hero */}
            <div className="about-hero">
                <div className="hero-content">
                    <h1>2 Level Pit Parking System</h1>
                    <p>
                        A space-efficient underground parking solution that stacks two vehicles below the ground level — perfect for locations where surface space is extremely limited.
                    </p>
                </div>
            </div>

            {/* Description */}
            <div className="about-section">
                <h2>What is 2 Level Pit Parking?</h2>
                <p>
                    2 Level Pit Parking is a semi-automatic system that allows two cars to be parked one above the other using a single pit. One car remains underground while the upper platform is level with the driveway or ground surface.
                </p>
                <p>
                    This solution is popular in residential and mixed-use developments where maximizing parking without affecting aesthetics is a priority. It’s compact, safe, and highly reliable.
                </p>
            </div>

            {/* Features */}
            <div className="about-section">
                <h2>Key Features & Benefits</h2>
                <ul className="lt-puzzle-list">
                    {features.map((item, index) => (
                        <li key={index}><CheckCircle size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* How it Works */}
            <div className="about-section">
                <h2>How It Works</h2>
                <p>
                    The user drives the car onto a steel platform at ground level. With the press of a button, the platform lowers into the pit, making room for another car to be parked on top. When retrieving the underground car, the top car must be moved if it’s not an independent-access type.
                </p>
                <p>
                    Built-in sensors, electro-mechanical locking, and user-friendly controls ensure smooth, safe, and dependable operation.
                </p>
            </div>

            {/* Applications */}
            <div className="about-section">
                <h2>Best Suited For</h2>
                <ul className="lt-puzzle-list">
                    {applications.map((item, index) => (
                        <li key={index}><Building2 size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* Call to Action */}
            <div className="lt-puzzle-cta">
                <div className="lt-puzzle-cta-content">
                    <h3>Looking for a 2 Level Pit Parking System?</h3>
                    <p>Contact LIFTECH ENGINEERING PVT. LTD. to get your site evaluated and start with the best compact solution.</p>
                    <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
                        <PhoneCall size={18} /> Request Consultation
                    </button>
                </div>
            </div>
        </section>
    );
};

export default TwoLevelPitParkingDetail;
